import React, { useEffect, useRef } from "react";
import { FaBootstrap, FaBullseye, FaEye, FaWrench } from "react-icons/fa";
import {
  FaHtml5,
  FaCss3Alt,
  FaJs,
  FaReact,
  FaJava,
  FaDatabase,
  FaPython,
  FaAndroid,
} from "react-icons/fa";
import {SiPython ,SiFrappe,SiTailwindcss,SiTypescript } from "react-icons/si";
import "../Cards.css";
import AboutUs from "./AboutUs";
import CounterSection from "./CounterSection";
import WhyChoose from "./WhyChoose";
import { Link } from "react-router-dom";

const servicesData = [
  {
    icon: <FaBullseye />,
    title: "Our Vision",
    description:
      "Empower global businesses with advanced technology that enables seamless digital transformation.",
  },
  {
    icon: <FaEye />,
    title: "Our Mission",
    description:
      "To provide high-quality IT solutions, innovative software products, and superior customer support that drives efficiency and growth for our clients.",
  },
  {
    icon: <FaWrench />,
    title: "Quality Policy",
    description:
      "We develop secure, robust, and functional technology products, often emphasising high efficiency and bug-free delivery.",
  },
];

const technologyData = [
  {
    id: 1,
    name: "HTML",
    icon: <FaHtml5 />,
    color: "#E44D26",
    bgColor: "#FFF2ED",
  },
  {
    id: 2,
    name: "CSS",
    icon: <FaCss3Alt />,
    color: "#1572B6",
    bgColor: "#EDF3FA",
  },
  {
    id: 3,
    name: "JavaScript",
    icon: <FaJs />,
    color: "#F7DF1E",
    bgColor: "#FEFCE8",
  },
   {
    id: 4,
    name: "Bootstrap",
    icon: <FaBootstrap />,
    color: "#712cf9",
    bgColor: "#d5daf4",
  },
  {
    id: 5,
    name: "React",
    icon: <FaReact />,
    color: "#61DAFB",
    bgColor: "#E8F9FE",
  },
  {
    id: 6,
    name: "TypeScript",
    icon: <SiTypescript />,
    color: "#3178C6",
    bgColor: "#EBF1FA",
  },
{
  id: 7,
  name: "Tailwind CSS",
  icon: <SiTailwindcss />,
  color: "#06B6D4",
  bgColor: "#E6FFFA",
},
  {
    id: 8,
    name: "Python",
    icon: <FaPython />,
    color: "#a89d04",
    bgColor: "#fafaeb",
  },
  {
    id: 9,
    name: "Java",
    icon: <FaJava />,
    color: "#007396",
    bgColor: "#E8F0F3",
  },
  {
    id: 10,
    name: "Android",
    icon: <FaAndroid />,
    color: "#3DDC84",
    bgColor: "#E8F5E9",
  },
  {
    id: 11,
    name: "React Native",
    icon: <FaReact />,
    color: "#61DAFB",
    bgColor: "#E8F9FE",
  },
  {
    id: 12,
    name: "SQL",
    icon: <FaDatabase />,
    color: "#F29111",
    bgColor: "#FFF5E8",
  },
 {
  id: 13,
  name: "Frappe",
  icon: <SiFrappe />,
  color: "#0089FF",
  bgColor: "#EAF4FF",
},
 
];

const duplicatedTechData = [...technologyData, ...technologyData, ...technologyData];

const About = () => {
  const scrollContainerRef = useRef(null);
  const animationRef = useRef(null);
  const isHoveredRef = useRef(false);

  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    if (!scrollContainer) return;

    const startAutoScroll = () => {
      if (animationRef.current) cancelAnimationFrame(animationRef.current);
      
      const step = () => {
        if (!scrollContainer || isHoveredRef.current) {
          animationRef.current = requestAnimationFrame(step);
          return;
        }
        
        scrollContainer.scrollLeft += 1.5;
        
        if (scrollContainer.scrollLeft >= scrollContainer.scrollWidth / 3) {
          scrollContainer.scrollLeft = 0;
        }
        
        animationRef.current = requestAnimationFrame(step);
      };
      
      animationRef.current = requestAnimationFrame(step);
    };
    
    startAutoScroll();
    
    return () => {
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
    };
  }, []);

  const handleMouseEnter = () => {
    isHoveredRef.current = true;
  };

  const handleMouseLeave = () => {
    isHoveredRef.current = false;
  };

  return (
    <>
      <div
        className="container-fluid p-0 banner-section"
        style={{ backgroundImage: "url('/img/bc.webp')" }}
      >
        <div className="overlay"></div>
        <div className="row">
          <div className="col-md-12 mt-5 text-white text-center">
            <h1 className="pt-5 mt-2">About Us</h1>
            <nav>
              <ol className="breadcrumb justify-content-center bg-transparent">
                <li className="breadcrumb-item">
                  <Link to="/" className="text-white text-decoration-none">
                    Home
                  </Link>
                </li>
                <li
                  className="breadcrumb-item active text-white"
                  aria-current="page"
                >
                  About US
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>

      <AboutUs />

      <div className="technology-section">
        <div className="text-center pt-2">
          <span className="section-badge">BEST TECH BEST FUTURE</span>
          <h1 className="fw-bold display-5 mb-4">Technology We Use</h1>
          <p className="tech-subtitle text-secondary mx-auto">
            We leverage modern technologies to build powerful and scalable solutions
          </p>
        </div>

        <div 
          className="tech-slider-container"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <div className="tech-slider-wrapper" ref={scrollContainerRef}>
            <div className="tech-slider-track">
              {duplicatedTechData.map((tech, index) => (
                <div className="tech-slide" key={`${tech.id}-${index}`}>
                  <div
                    className="tech-icon-wrapper"
                    style={{ backgroundColor: tech.bgColor, color: tech.color }}
                  >
                    {tech.icon}
                  </div>
                  <h3 className="tech-title">{tech.name}</h3>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <CounterSection />

      <div className="container pt-4 mt-4">
        <div className="row">
          {servicesData.map((service, index) => (
            <div className="column" key={index}>
              <div className="card">
                <div className="icon-wrapper">{service.icon}</div>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </div>
            </div>
          ))}
        </div>

        <WhyChoose />
      </div>

      <style>{`
        .technology-section {
          border-radius: 2rem;
          padding: 10px 20px;
          margin: 2rem auto;
          position: relative;
          overflow: hidden;
          max-width: 1400px;
        }

        .section-badge {
          display: inline-block;
          background: linear-gradient(135deg, #1a2a3a, #0f1a24);
          color: #b8f2ff;
          font-weight: 600;
          font-size: 0.8rem;
          letter-spacing: 1.5px;
          padding: 0.4rem 1.2rem;
          border-radius: 40px;
          text-transform: uppercase;
          margin-bottom: 1rem;
        }

        .tech-subtitle {
          font-size: 1rem;
          color: #6c757d;
        }

        .tech-slider-container {
          position: relative;
          width: 100%;
          margin-top: 2rem;
          overflow: hidden;
        }

        .tech-slider-wrapper {
          overflow-x: auto;
          overflow-y: hidden;
          scrollbar-width: none;
          -ms-overflow-style: none;
          cursor: grab;
          scroll-behavior: auto;
        }

        .tech-slider-wrapper::-webkit-scrollbar {
          display: none;
        }

        .tech-slider-track {
          display: flex;
          gap: 1.8rem;
          padding: 0.8rem 0.5rem;
          width: max-content;
        }

        .tech-slide {
          min-width: 170px;
          flex-shrink: 0;
          text-align: center;
          padding: 1.8rem 1rem;
          background: white;
          border-radius: 1.5rem;
          box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);
          border: 1px solid rgba(0, 0, 0, 0.05);
        }

        .tech-icon-wrapper {
          width: 90px;
          height: 90px;
          margin: 0 auto 1.2rem;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 1.5rem;
          font-size: 3.2rem;
        }

        .tech-title {
          font-size: 1.2rem;
          font-weight: 700;
          margin: 0;
          color: #1a2a3a;
          letter-spacing: -0.3px;
        }

        @media (max-width: 768px) {
          .technology-section {
            padding: 2rem 1rem;
          }

          .tech-slider-track {
            gap: 1.2rem;
          }

          .tech-slide {
            min-width: 140px;
            padding: 1.2rem 0.8rem;
          }

          .tech-icon-wrapper {
            width: 70px;
            height: 70px;
            font-size: 2.5rem;
          }

          .tech-title {
            font-size: 1rem;
          }
        }

        @media (max-width: 576px) {
          .tech-slide {
            min-width: 120px;
          }

          .tech-icon-wrapper {
            width: 60px;
            height: 60px;
            font-size: 2rem;
          }
        }

        .tech-slide {
          opacity: 0;
          animation: fadeInUp 0.5s ease forwards;
        }

        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .tech-slide:nth-child(1) { animation-delay: 0.05s; }
        .tech-slide:nth-child(2) { animation-delay: 0.1s; }
        .tech-slide:nth-child(3) { animation-delay: 0.15s; }
        .tech-slide:nth-child(4) { animation-delay: 0.2s; }
        .tech-slide:nth-child(5) { animation-delay: 0.25s; }
        .tech-slide:nth-child(6) { animation-delay: 0.3s; }
        .tech-slide:nth-child(7) { animation-delay: 0.35s; }
        .tech-slide:nth-child(8) { animation-delay: 0.4s; }
        .tech-slide:nth-child(9) { animation-delay: 0.45s; }
        .tech-slide:nth-child(10) { animation-delay: 0.5s; }

        .tech-slider-container::before,
        .tech-slider-container::after {
          content: '';
          position: absolute;
          top: 0;
          bottom: 0;
          width: 60px;
          pointer-events: none;
          z-index: 2;
        }

        .tech-slider-container::before {
          left: 0;
          background: linear-gradient(to right, #f8f9fa, transparent);
        }

        .tech-slider-container::after {
          right: 0;
          background: linear-gradient(to left, #ffffff, transparent);
        }

        @media (max-width: 768px) {
          .tech-slider-container::before,
          .tech-slider-container::after {
            width: 30px;
          }
        }
      `}</style>
    </>
  );
};

export default About;